import { createFileRoute } from '@tanstack/react-router'
import { Link2 } from 'lucide-react'
import { ConnectedProductsScreen } from '@/screens/federation/SCR-145-products'

// SCR-145 Connected products (identity federation area).
export const Route = createFileRoute('/_app/org/products')({
  staticData: {
    screen: {
      id: 'SCR-145',
      title: 'Connected products',
      group: 'Organisation',
      perm: 'identity.manage',
      order: 7,
      description: 'Adya products and your own apps that use this organisation’s memory.',
      icon: Link2,
    },
  },
  component: ConnectedProductsScreen,
})
